import { ReactNode } from 'react-dom';
import * as React from 'react';

import { Hierarchy } from './types';

import { BentoPlaceholder, WithRenderer } from './bento-placeholder';
import { componentRenderer, defineLayout, renderAll } from './layout';
import { NavigationRefs } from 'components/infosite/navigation/navigation-refs';
import { TabGroup } from 'components/common/tab-group';

defineLayout('identity', {
  generate: (hierarchy: Hierarchy, getComponentCallback: (string) => ReactNode, options: object): ReactNode => (
    <>{renderAll(hierarchy, getComponentCallback)}</>
  )
});

defineLayout('column', {
  generate: (hierarchy: Hierarchy, getComponentCallback: (string) => ReactNode, options: object): ReactNode => (
    <div className="layout-column uitk-flex uitk-flex-column">{renderAll(hierarchy, getComponentCallback)}</div>
  )
});

defineLayout('two-col', {
  generate: (hierarchy: Hierarchy, getComponentCallback: (string) => ReactNode, options: object): ReactNode => {
    const renderer = componentRenderer(hierarchy, getComponentCallback);

    return (
      <WithRenderer value={renderer}>
        <div className="uitk-grid all-cell-1-2 all-x-gutter-six">
          <div className="uitk-cell">
            <BentoPlaceholder region="left" />
          </div>
          <div className="uitk-cell">
            <BentoPlaceholder region="right" />
          </div>
        </div>
      </WithRenderer>
    );
  }
});

defineLayout('tabbed', {
  generate: (hierarchy: Hierarchy, getComponentCallback: (string) => ReactNode, options: object): ReactNode => {
    const renderer = componentRenderer(hierarchy, getComponentCallback);
    const tabs = (options && options['tabs']) || [];
    const rfrrIds = (options && options['rfrrids']) || [];

    if (tabs.length === 0) {
      return false;
    }

    const tabData =
      tabs.map &&
      tabs.map((label, index) => ({
        id: `tab${index}`,
        label,
        rfrr: rfrrIds[index],
        content: <>{renderer(`tab${index}`)}</>
      }));

    return (
      <WithRenderer value={renderer}>
        <BentoPlaceholder region="header" />
        <TabGroup tabs={tabData} ref={NavigationRefs.PageTabs} />
        <BentoPlaceholder region="footer" />
      </WithRenderer>
    );
  }
});
